import { RapierRigidBody, RigidBody } from '@react-three/rapier';
import { useEffect, useRef } from 'react';
import { useGame } from './score-context';

export function Ball({ position }: { position: [number, number, number] }) {
  const game = useGame();
  const ballRef = useRef<RapierRigidBody>(null);

  // Store the initial randomized position in a ref
  const initialPosition = useRef([
    position[0] + (Math.random() - 0.5) * 0.1,
    position[1] + (Math.random() - 0.5) * 0.1,
    position[2],
  ] as const);

  useEffect(() => {
    const ball = ballRef.current;
    if (!ball) return;

    if (game.isDropped) {
      ball.setGravityScale(1, true);
    } else {
      ball.setGravityScale(0, true);
    }

    // This seems necessary even though setGravityScale should also wake it up
    ball.wakeUp();
  }, [game.isDropped]);

  return (
    <RigidBody
      ref={ballRef}
      gravityScale={0}
      name="ball"
      position={initialPosition.current}
      colliders="ball"
      restitution={2}
      friction={0.1}
      linearDamping={0}
      enabledTranslations={[true, true, false]} // Lock Z-axis movement
      enabledRotations={[true, true, true]} // Only allow rotation around Z-axis
    >
      <mesh castShadow>
        <sphereGeometry args={[0.5, 32, 32]} />
        <meshStandardMaterial color="#ff4444" metalness={0.3} roughness={0.4} />
      </mesh>
    </RigidBody>
  );
}
